import React from "react";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { ProductCard } from "../components/global/ProductCard";
import { useWishlist } from "../context/wishlist-context";

const Wishlist = () => {
  const { wishlist } = useWishlist();

  return (
    <Box sx={{ px: { xs: 2, sm: 4, md: 6, lg: 10 }, pt: { xs: 5, md: 8 }, pb: { xs: 8, md: 12 } }}>
      <Box sx={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", mb: { xs: 3, md: 4 }, borderBottom: "1px solid #e5e7eb", pb: 3 }}>
        <Typography sx={{ fontSize: { xs: 24, md: 32 }, fontWeight: 300, letterSpacing: "-0.03em", color: "#111827" }}>
          Wishlist
        </Typography>
        {wishlist.length > 0 && (
          <Typography sx={{ fontSize: 13, color: "#9ca3af" }}>
            {wishlist.length} item{wishlist.length !== 1 ? "s" : ""}
          </Typography>
        )}
      </Box>

      {wishlist.length === 0 ? (
        <Box sx={{ textAlign: "center", py: { xs: 8, md: 14 } }}>
          <FavoriteBorderIcon sx={{ fontSize: 48, color: "#e5e7eb", mb: 2 }} />
          <Typography sx={{ fontSize: 16, color: "#9ca3af", mb: 1 }}>Your wishlist is empty</Typography>
          <Typography sx={{ fontSize: 13, color: "#d1d5db", mb: 4 }}>
            Save items you love by clicking the heart icon on any product.
          </Typography>
          <Box
            component={Link}
            to="/shop"
            sx={{
              display: "inline-block",
              px: 4,
              py: 1.5,
              bgcolor: "#194049",
              color: "#fff",
              fontSize: 12,
              letterSpacing: "0.12em",
              textTransform: "uppercase",
              textDecoration: "none",
              borderRadius: "6px",
              "&:hover": { bgcolor: "#0f2a31" },
            }}
          >
            Browse Shop
          </Box>
        </Box>
      ) : (
        <Grid container spacing={{ xs: 1.5, sm: 2, md: 2.5 }}>
          {wishlist.map((item) => (
            <Grid item xs={6} sm={4} md={3} key={item.id}>
              <ProductCard
                id={item.id}
                imgSrc={item.imgSrc}
                title={item.title}
                path={item.path}
                price={item.price}
                slug={item.slug}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default Wishlist;
